import { render } from "./App.vue?vue&type=template&id=2cf323f2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2cf323f2&lang=css"

import exportComponent from "C:\\Users\\arttu\\Downloads\\flipbook-vue-master\\examples\\demo\\node_modules\\.pnpm\\vue-loader@17.0.0_webpack@5.74.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__